import { render, staticRenderFns } from "./TaskEditModal.vue?vue&type=template&id=129d8e1d&scoped=true"
import script from "./TaskEditModal.vue?vue&type=script&lang=js"
export * from "./TaskEditModal.vue?vue&type=script&lang=js"
import style0 from "./TaskEditModal.vue?vue&type=style&index=0&id=129d8e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d8e1d",
  null
  
)

export default component.exports